import { MixpanelEvent, useMixpanel } from '@talos/kyoko';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import type {
  GenerateOrderDetailsRoute,
  OrderDetailsPath,
  OrderRouteType,
} from '../containers/Trading/Markets/OrderDetails/types';

export function useNavigateToOrderDetails(
  generateOrderDetailsRoute: GenerateOrderDetailsRoute,
  layoutId: string | undefined
) {
  const mixpanel = useMixpanel();
  const navigate = useNavigate();
  return useCallback(
    (orderID: string, type: OrderRouteType = 'order', tab: OrderDetailsPath = 'details') => {
      mixpanel.track(MixpanelEvent.OpenOrderDetails);
      navigate(generateOrderDetailsRoute({ orderID, tab, type, layoutId }));
    },
    [mixpanel, navigate, generateOrderDetailsRoute, layoutId]
  );
}
